var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container",attrs:{"id":"heading-comp"}},[_c('p',{staticClass:"text-center mt-5",attrs:{"id":"skills"}},[_vm._v(_vm._s(_vm.subtitle))]),_c('h1',{staticClass:"title text-center mb-5"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }